import React from "react";
import cx from "classnames";
import styles from "./style.module.scss";
const TagName = ({ element, className, children }) => {
  return React.createElement(
    element,
    { className: cx(className.map(classx => styles[classx])) },
    children
  );
};
export default TagName;
